import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const startPriceValidator: SchemaItem['x-validator'] = {
  required: true,
  validator(_, __, ctx) {
    const { startPrice } = ctx.form.values
    if (isNil(startPrice)) {
      return '起拍价不能为空'
    }
    return null
  }
}
